import { useEffect, useState } from "react";

import { getStatsTopCategories, StatsPeriodFilter } from "services/stats/rest";
import { StatsCategoryRevenueDto } from "services/stats/restModels";

export interface UseStatsTopCategoriesResult {
    categories: StatsCategoryRevenueDto[];
    loading: boolean;
    error: boolean;
}

// Топ категорий по выручке за период. Размер топа задаёт вызывающий — бэк отдаёт уже
// отсортированную и обрезанную выборку.
export const useStatsTopCategories = (
    filter: StatsPeriodFilter | null,
    limit: number
): UseStatsTopCategoriesResult => {
    const [categories, setCategories] = useState<StatsCategoryRevenueDto[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);

    const menuId = filter === null ? null : filter.menuId;
    const from = filter === null ? null : filter.from;
    const to = filter === null ? null : filter.to;

    useEffect(() => {
        if (menuId === null || from === null || to === null) {
            setCategories([]);
            setLoading(false);
            return undefined;
        }

        let ignore = false;

        setLoading(true);
        setError(false);

        getStatsTopCategories({ menuId, from, to }, limit)
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setCategories(result);
                } else {
                    setError(true);
                    setCategories([]);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
                setCategories([]);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, [menuId, from, to, limit]);

    return { categories, loading, error };
};
